import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observer } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServiceFilter } from '../interfaces/service-filter';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  constructor(
    private httpClient: HttpClient,
    private dataService: DataService
  ) { }

  async get(id: number): Promise<any|null> {
    return new Promise((resolve: CallableFunction, reject: CallableFunction) => {
      this.httpClient.get(`${environment.url}/settings/get/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        withCredentials: true
      })
      .subscribe({
        next: (response: any) => {
          if (!!response === false || response.error === true) {
            // console.log(response);
            return reject(null);
          }
          return resolve(response.data);
        },
        error: (error: any) => {
          // console.log(error);
          return reject(null);
        },
        complete: () => {
          // console.log('user() complete');
        }
      } as Observer<any>);
    });
  }

  async list(filters: Array<ServiceFilter>=[], page: number|null = null, perPage: number|null = null): Promise<any|Array<any>> {
    return new Promise((resolve: CallableFunction, reject: CallableFunction) => {
      let params: any = {};

      if (!!page) {
        params.page = page;
        params.perPage = perPage ?? 10;
      }

      if (!!filters && filters.length > 0) {
        params.filters = JSON.stringify(filters);
      }

      this.dataService.httpGet(`/settings/list`,params).then((response: any)=>{
          resolve(response)
      });
      // this.httpClient.get(`${environment.url}/settings/list`, {
      //   headers: {
      //     'Content-Type': 'application/json',
      //     'Accept': 'application/json'
      //   },
      //   withCredentials: true,
      //   params
      // })
      // .subscribe({
      //   next: (response: any) => {
      //     if (!!response === false || response.error === true) {
      //       // console.log(response);
      //       return reject(null);
      //     }

      //     return resolve(response);
      //   },
      //   error: (error: any) => {
      //     // console.log(error);
      //     return reject(null);
      //   },
      //   complete: () => {
      //     // console.log('user() complete');
      //   }
      // } as Observer<any>);
    });
  }

  async save(data: any): Promise<any> {
    return new Promise((resolve: CallableFunction, reject: CallableFunction) => {
      this.httpClient.post(`${environment.url}/settings/save`, data.toObjectWithSnakeCase(), {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        withCredentials: true
      })
      .subscribe({
        next: (response: any) => {
          if (!!response === false || response.error === true) {
            // console.log(response);
            return reject(null);
          }
          return resolve(response.data);
        },
        error: (error: any) => {
          // console.log(error);
          return reject(null);
        },
        complete: () => {
          // console.log('user() complete');
        }
      } as Observer<any>);
    });
  }

  async delete(id: number): Promise<any> {
    return new Promise((resolve: CallableFunction, reject: CallableFunction) => {
      this.httpClient.delete(`${environment.url}/settings/delete/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        withCredentials: true
      })
      .subscribe({
        next: (response: any) => {
          if (!!response === false || response.error === true) {
            // console.log(response);
            return reject(null);
          }
          return resolve(response);
        },
        error: (error: any) => {
          // console.log(error);
          return reject(null);
        },
        complete: () => {
          // console.log('user() complete');
        }
      } as Observer<any>);
    });
  }

}
